import PaymentService from './../services/payment.service'
import EMRService from './../services/emr.service'

// action types
export const POST_PAYMENT = 'PostPayment'
export const CONFIRM_PAYMENT = 'ConfirmPayment'
export const FUND_WALLET = 'FundWallet'

// mutation types
export const SET_PAYMENT = 'SetPayment'
export const SET_TRANSACTION = 'SetTransaction'
export const SET_ERROR = 'SetError'

// state
const state = {
  errors: null,
  paymentDetails: {},
  transactionDetails: {}
}

// getters
const getters = {
  currentPayment (state) {
    return state.paymentDetails
  },
  currentTransaction (state) {
    return state.transactionDetails
  }
}

// actions
const actions = {
  [POST_PAYMENT] (context, params) {
    return new Promise((resolve, reject) => {
      PaymentService.post(params)
        .then(response => {
          console.log(response)
          context.commit(SET_PAYMENT, response.data.data)
          resolve(response)
        })
        .catch(e => {
          reject(e)
          console.log(e)
          context.commit(SET_ERROR, e)
        })
    })
  },
  [CONFIRM_PAYMENT] (context, params) {
    return new Promise((resolve, reject) => {
      PaymentService.confirm(params)
        .then(response => {
          console.log(response)
          context.commit(SET_PAYMENT, response.data.data)
          resolve(response)
        })
        .catch(e => {
          reject(e)
          console.log(e)
          context.commit(SET_ERROR, e)
        })
    })
  },
  [FUND_WALLET] (context, params) {
    return new Promise((resolve, reject) => {
      EMRService.fundWallet(params)
        .then(response => {
          console.log(response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
          console.log(e)
          context.commit(SET_ERROR, e)
        })
    })
  }
}

// mutations
const mutations = {
  [SET_ERROR] (state, error) {
    state.errors = error
  },

  [SET_PAYMENT] (state, data) {
    state.paymentDetails = data
    state.errors = {}
  },

  [SET_TRANSACTION] (state, data) {
    state.transactionDetails = data.transaction
    state.errors = {}
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/payment.module.js